import { BookingStatus } from 'api/types'

export const translateStatus = (status: BookingStatus) => {
  switch (status) {
    case 'SENDING':
      return 'global.bookingStatus.sending'
    case 'SENT':
      return 'global.bookingStatus.sent'
    case 'APPROVED':
      return 'global.bookingStatus.approved'
    case 'CANCELLED':
      return 'global.bookingStatus.cancelled'
    case 'CANCELLING':
      return 'global.bookingStatus.cancelling'
    case 'STARTED':
      return 'global.bookingStatus.started'
    case 'FINISHED':
      return 'global.bookingStatus.finished'
  }
}
